<div class="agent-card">
  <div class="agent-info">
      <div class="avatar">
          <app-avatar [avatarSize]="isMobile ? 42 : 108" [photoUuid]="agentDto.photoUuid || agentDto.photo"></app-avatar>
          <div class="rating rating-desktop"  *ngIf="!isMobile && !isProfileAgent && agentDto.averageClientRating">
            <i class="pi pi-star-fill"></i>
            <span class="number">{{ roundNumber(agentDto.averageClientRating) }}</span>
          </div>
      </div>
      <div class="personal-information">
        <div class="agent-name">{{ agentDto.name }} {{ agentDto.surname }} {{ agentDto.patronymic }}</div>
        <div class="agent-skill">Специалист пo недвижимости</div>
        <div class="achievement" *ngIf="isProfileAgent && agentDto.agentAchievement">
          <img class="icon" [src]="getImageUrl()" alt=""> {{ getAchievementTitle() }}
        </div>
        <div class="rating rating-mobile"  *ngIf="isMobile && !isProfileAgent && agentDto.averageClientRating">
          <i class="pi pi-star-fill"></i>
          <span class="number">{{ roundNumber(agentDto.averageClientRating) }}</span>
        </div>
      </div>
  </div>
  <div class="agent-buttons mt-24">
      <div class="button">
          <app-button
                  [iconDirection]="'left'"
                  [icon]="'./assets/images/new-design-icons/phone.svg'"
                  [text]="textButton"
                  [buttonClass]="'big-light-gray'"
                  (buttonClick)="changeTextButton()"
          ></app-button>
      </div>
      <div class="button">
          <app-button
                  [text]="'Показать всe обьекты / ' + totalObjects"
                  [buttonClass]="'big-purple-gradient'"
                  (buttonClick)="navigateToObjects.emit()"
          ></app-button>
      </div>
  </div>
</div>